import { render, staticRenderFns } from "./splitScreen.vue?vue&type=template&id=2cdf60ac&scoped=true"
import script from "./splitScreen.vue?vue&type=script&lang=js"
export * from "./splitScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdf60ac",
  null
  
)

export default component.exports